import React, { useState, useEffect, useRef } from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import Clear from "@material-ui/icons/Clear";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import MsgDataService from "../../services/MsgService";
import { routes } from "../../constants/constant.route";
import Loader from "react-loader-spinner";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
// New UI icon assets
import attachmentIcon from "../../assets/images/CouselorMessages/SingleChat/attachment.png";
import checkmarkIcon from "../../assets/images/CouselorMessages/SingleChat/Checkmark.png";
import checkmarkselected from "../../assets/images/CouselorMessages/SingleChat/Checkmark Selected.png";
import sendIcon from "../../assets/images/CouselorMessages/SingleChat/send.png";
import closeIcon from "../../assets/images/CouselorMessages/SingleChat/close.png";
import OtpVerifyModal from "./OtpVerifyModal";
import swal from "sweetalert";
import {
  buildRecruiterStudentParentPayload,
  getParentMessageEmail,
  hasRecruiterStudentParentSelection } from
"../../utils/recruiterMessagePayload";
import { buildCounselorStudentParentPayload } from "../../utils/counselorMessagePayload";
import MessageSendSpinner from "../shared/MessageSendSpinner";
import "./NewMessageModal.css";
import "./OtpVerifyModal.css";

const getApiErrorMessage = (error) => {
  const data = error?.response?.data;
  if (!data) {
    return error?.message || "Something went wrong. Please try again.";
  }
  if (typeof data === "string") return data;
  if (Array.isArray(data)) return data.join(", ");
  return (
    data.message ||
    data.error_message ||
    data.error ||
    data.detail ||
    data.Error || (
    Array.isArray(data.non_field_errors) ? data.non_field_errors.join(", ") : null) ||
    "Something went wrong. Please try again.");

};

const showApiError = (error) => {
  swal({
    text: getApiErrorMessage(error),
    icon: "warning",
    dangerMode: true,
    buttons: { confirm: true },
    closeOnClickOutside: false
  });
};

const getApiSuccessMessage = (data, fallback = "Your message has been sent successfully!") => {
  const payload = data?.data;
  if (!payload) return fallback;
  if (typeof payload === "string") return payload;
  return (
    payload.Status ||
    payload.message ||
    payload.status_message ||
    fallback);

};

const showSendSuccess = (data, fallback = "Your message has been sent successfully!") => {
  swal({
    title: "Success!",
    text: getApiSuccessMessage(data, fallback),
    icon: "success",
    buttons: { OK: true },
    closeOnClickOutside: false
  });
};

const getParentDisplayEmail = (item) =>
  typeof item === "string" ? item : item?.parent_email || item?.email || item?.mail || "";

const getParentDisplayName = (item) =>
  typeof item === "string" ? item : item?.name || item?.parent_name || item?.full_name || item?.label || "";

const normalizeParentStudentIds = (ids) => {
  const list = Array.isArray(ids) ? ids : ids != null && ids !== "" ? [ids] : [];
  return list
    .map((id) => {
      if (id == null || id === "") return null;
      const numericId = Number(id);
      return Number.isFinite(numericId) ? numericId : id;
    })
    .filter((id) => id != null && id !== "");
};

const getParentStudentIds = (item) => {
  if (!item) return [];
  if (Array.isArray(item)) {
    if (item.length && typeof item[0] === "object") {
      return item.flatMap((row) => getParentStudentIds(row));
    }
    return normalizeParentStudentIds(item);
  }
  const ids = item.student_ids || item.studentIds || item.child_ids || item.dst_id;
  if (ids != null && ids !== "") return normalizeParentStudentIds(ids);
  if (item.id != null && item.id !== "") return normalizeParentStudentIds(item.id);
  return [];
};

const unwrapParentSearchList = (value, depth = 0) => {
  if (!value || depth > 4) return [];
  if (Array.isArray(value)) return value;
  if (typeof value !== "object") return [];
  return unwrapParentSearchList(
    value.data ?? value.parents ?? value.objects ?? value.results ?? value.result,
    depth + 1
  );
};

const extractParentSearchResults = (payload) =>
  unwrapParentSearchList(payload)
    .map((item) => {
      if (typeof item === "string") {
        const email = item.trim();
        return email ? { parent_email: email, student_ids: [] } : null;
      }
      const email = getParentDisplayEmail(item);
      if (!email) return null;
      return {
        parent_email: email,
        student_ids: getParentStudentIds(item)
      };
    })
    .filter(Boolean);

const ModalExample = ({
  open,
  closeHandler,

  isStudentOrCounselor,
  getMsgData,
  NameOrGroupName,
  setNameOrGroupName,
  setMsg,
  msg,
  selectedGroupMessageStudent,


  setShowNotificationAlert,
  setOpen,
  setSelectedGroupMessageStudent,
  numberOfStudents,
  freshCompose = false
  // page,
}) => {
  const ref = useRef();
  const inputRef = useRef();
  const timeout = useRef();
  const parentSearchTimeout = useRef();
  const parentSearchRequestId = useRef(0);
  const lastParentQuery = useRef("");
  const location = useLocation();
  const [page] = useState(1); // retained if pagination needed later
  const [cannedMsgData, setCannedMsgData] = useState("");
  const [openAccordion, setOpenAccordion] = useState(false);
  const [student, setStudent] = useState([]);
  const [showStudentContainer, setShowStudentContainer] = useState(false);
  const [loadingNameForStudent, setLoadingNameForStudent] = useState(false);
  const [messageId, setMessageId] = useState();
  const [selected, setSelected] = useState(false);
  const [sendToStudent, setSendToStudent] = useState(false);
  const [sendToParent, setSendToParent] = useState(false);
  const [groupSendStudents, setGroupSendStudents] = useState(false);
  const [groupSendParents, setGroupSendParents] = useState(false);
  const [sending, setSending] = useState(false);
  const [selectedfile, setSelectedFile] = useState();
  const [fileDatafromApi, setFileDataFromApi] = useState();
  const [messageVerified, setMessageVerified] = useState(false);
  const [verifyNudgeResponse, setVerifyNudgeResponse] = useState(null);
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [verifying, setVerifying] = useState(false);
  const [otpSubmitting, setOtpSubmitting] = useState(false);
  const [otpResending, setOtpResending] = useState(false);
  const [otpResendTick, setOtpResendTick] = useState(0);
  const userData = useSelector((state) => state.UserReducer.userObj);

  const isSelectAllGroupMessage =
  NameOrGroupName === "selected All" || location?.requireVerifyFlow === true;

  const getMessageBody = () =>
  typeof msg === "object" ? msg?.messages?.en?.body : msg;

  const getEventType = () => {
    const inCounselorContext =
    (location?.pathname || "").startsWith("/counselor") ||
    (location?.pathname || "").startsWith("/super_admin");
    if (isStudentOrCounselor === "counselors") return "recruiter_counselor";
    if (isStudentOrCounselor === "students") {
      return inCounselorContext ? "counselor_student" : "recruiter_student";
    }
    if (isStudentOrCounselor === "international-students") return "international_student";
    if (isStudentOrCounselor === "parents") {
      return inCounselorContext ? "counselor_parent" : "recruiter_parent";
    }
    return null;
  };

  const buildAllSelectedPayload = () => {
    const query = JSON.parse(localStorage.getItem("query"));
    const baseEventType = getEventType();
    const body = {
      message_body: getMessageBody(),
      is_all: true,
      query: [query],
      event_type: baseEventType
    };
    if (isStudentOrCounselor === "international-students") body.is_international = true;

    if (baseEventType === "recruiter_student") {
      // Student / Parent selection toggles drive the event type and parent_ack
      if (groupSendStudents && groupSendParents) {
        body.event_type = "recruiter_student";
        body.parent_ack = true;
      } else if (groupSendParents) {
        body.event_type = "recruiter_parent";
        body.parent_ack = true;
      } else {
        body.event_type = "recruiter_student";
      }
    } else if (selected && isStudentOrCounselor !== "international-students") {
      body.parent_ack = selected;
    }

    if (fileDatafromApi) body.attachment_url = fileDatafromApi?.Status?.image_name;
    return body;
  };

  const resetVerifyFlowState = () => {
    setMessageVerified(false);
    setVerifyNudgeResponse(null);
    setShowOtpModal(false);
    setVerifying(false);
    setOtpSubmitting(false);
    setOtpResending(false);
    setGroupSendStudents(false);
    setGroupSendParents(false);
    setSendToStudent(false);
    setSendToParent(false);
  };

  const messageInputHandler = (e) => setMsg(e.target.value);
  const handleFileChange = async () => setSelectedFile(ref.current.files[0]);

  // Fetch students for autocomplete; parent tab searches by email with debounce
  const getParentData = (value) => {
    const query = String(value || "").trim();
    if (!query) {
      parentSearchRequestId.current += 1;
      setLoadingNameForStudent(false);
      setStudent([]);
      setShowStudentContainer(false);
      return;
    }
    const requestId = ++parentSearchRequestId.current;
    setLoadingNameForStudent(true);
    MsgDataService.searchParentsByEmail(
      query,
      (location?.pathname || "").startsWith("/counselor") || (location?.pathname || "").startsWith("/super_admin")
        ? "counselor"
        : "recruiter"
    )
    .then((data) => {
      if (requestId !== parentSearchRequestId.current) return;
      setStudent(extractParentSearchResults(data));
      setShowStudentContainer(true);
    })
    .catch(() => {
      if (requestId !== parentSearchRequestId.current) return;
      setStudent([]);
    })
    .finally(() => {
      if (requestId !== parentSearchRequestId.current) return;
      setLoadingNameForStudent(false);
    });
  };

  const getStudentData = (value) => {
    if (isStudentOrCounselor === "parents") {
      getParentData(value);
      return;
    }
    if (typeof NameOrGroupName === "string" || typeof value === "string") {
      MsgDataService.getList(isStudentOrCounselor, value)
      .then((data) => {
        setLoadingNameForStudent(false);
        setStudent(data.data.objects);
      })
      .catch(() => setLoadingNameForStudent(false));
    }
  };

  const handleNameOrGroupChange = () => {
    const nextValue = inputRef.current?.value || "";
    setNameOrGroupName(nextValue);
    setMessageId(undefined);
    if (isStudentOrCounselor === "parents") {
      if (parentSearchTimeout.current) clearTimeout(parentSearchTimeout.current);
      const query = nextValue.trim();
      if (!query) {
        parentSearchRequestId.current += 1;
        lastParentQuery.current = "";
        setLoadingNameForStudent(false);
        setStudent([]);
        setShowStudentContainer(false);
        return;
      }
      parentSearchTimeout.current = setTimeout(() => {
        const latest = String(inputRef.current?.value || "").trim();
        if (!latest || latest === lastParentQuery.current) {
          setLoadingNameForStudent(false);
          return;
        }
        lastParentQuery.current = latest;
        getParentData(latest);
      }, 600);
      return;
    }
    clearTimeout(timeout.current);
    if (!NameOrGroupName) {
      setShowStudentContainer(false);
      setStudent([]);
    }
    setLoadingNameForStudent(true);
    timeout.current = setTimeout(() => {
      getStudentData(inputRef.current.value);
    }, 800);
    setShowStudentContainer(true);
  };

  // Clear group selection when user starts typing
  const clearGroupSelection = () => {
    if (Array.isArray(NameOrGroupName) || NameOrGroupName === 'selected All') {
      setNameOrGroupName('');
      setMessageId(undefined);
    }
  };

  useEffect(() => {
    return () => {
      if (parentSearchTimeout.current) clearTimeout(parentSearchTimeout.current);
      if (timeout.current) clearTimeout(timeout.current);
    };
  }, []);

  useEffect(() => {
    if (!msg || isStudentOrCounselor === "international-students") setSelected(false);
  }, [msg, NameOrGroupName, isStudentOrCounselor]);

  useEffect(() => {
    setSendToStudent(false);
    setSendToParent(false);
  }, [NameOrGroupName, messageId]);

  const submitAttachment = () => {
    if (selectedfile) {
      MsgDataService.attachment(selectedfile)
      .then((data) => {
        setFileDataFromApi(data.data);
        ref.current.value = "";
      })
      .catch(() => {});
    }
  };
  useEffect(submitAttachment, [selectedfile]);

  const getCannedMsgData = () => {
    const counselorPath =
    (location?.pathname || "").startsWith("/counselor") ||
    (location?.pathname || "").startsWith("/super_admin");
    const role = counselorPath ? "counselor" : "recruiter";
    const orgId = counselorPath ? userData?.school_id : userData?.college;
    MsgDataService.getCannedMsgPage(role, orgId, page)
    .then((data) => setCannedMsgData(data.data?.result))
    .catch(() => {});
  };
  useEffect(getCannedMsgData, []);

  const accordionHandler = () => setOpenAccordion(!openAccordion);
  const selectTemplate = (item) => {setOpenAccordion(false);setMsg(item);};
  const selectStudent = (value) => {
    if (isStudentOrCounselor === "parents") {
      const parentEmail = getParentDisplayEmail(value);
      setNameOrGroupName({
        parent_email: parentEmail
      });
      setMessageId(undefined);
      setShowStudentContainer(false);
      return;
    }
    setNameOrGroupName(value);
    setMessageId(value?.id);
    setShowStudentContainer(false);
  };
  const sendCopyToParents = () => setSelected(!selected);
  const toggleGroupSendStudents = () => setGroupSendStudents((prev) => !prev);
  const toggleGroupSendParents = () => setGroupSendParents((prev) => !prev);
  const toggleSendToStudent = () => setSendToStudent((prev) => !prev);
  const toggleSendToParent = () => setSendToParent((prev) => !prev);

  const inCounselorContext =
  (location?.pathname || "").startsWith("/counselor") ||
  (location?.pathname || "").startsWith("/super_admin");

  const showStudentParentToggles =
  isSelectAllGroupMessage && getEventType() === "recruiter_student";
  const isMultiStudentSelection =
  Array.isArray(NameOrGroupName) && NameOrGroupName.length > 0;
  const isRecruiterStudentDirectMessage =
  isStudentOrCounselor === "students" &&
  !inCounselorContext &&
  !isSelectAllGroupMessage;
  const showRecruiterStudentParentToggles =
  isRecruiterStudentDirectMessage && (
  isMultiStudentSelection || !Array.isArray(NameOrGroupName));
  const noGroupRecipientSelected =
  showStudentParentToggles && !groupSendStudents && !groupSendParents;
  const noRecruiterStudentRecipientSelected =
  showRecruiterStudentParentToggles &&
  !hasRecruiterStudentParentSelection(sendToStudent, sendToParent);
  const isQueryPrefill = Boolean(location?.fromQueryResult) && !freshCompose;

  const isParentQueryContact =
  isStudentOrCounselor === "parents" &&
  isQueryPrefill && (
  location?.state?.contactType === "parent" ||
  selectedGroupMessageStudent &&
  !Array.isArray(selectedGroupMessageStudent) &&
  selectedGroupMessageStudent?.contactType === "parent");

  const parentRecipientEmail =
  getParentMessageEmail(NameOrGroupName) ||
  (location?.state?.contactType === "parent" ? getParentMessageEmail(location.state) : "") ||
  (selectedGroupMessageStudent?.contactType === "parent"
    ? getParentMessageEmail(selectedGroupMessageStudent)
    : "");
  const hasRecipientSelected =
  Array.isArray(NameOrGroupName) ?
  NameOrGroupName.length > 0 :
  isStudentOrCounselor === "parents" ?
  Boolean(String(parentRecipientEmail || "").trim()) :
  Boolean(messageId);

  const resetParentRecipient = () => {
    if (parentSearchTimeout.current) clearTimeout(parentSearchTimeout.current);
    parentSearchRequestId.current += 1;
    lastParentQuery.current = "";
    setMessageId(undefined);
    setStudent([]);
    setShowStudentContainer(false);
    setLoadingNameForStudent(false);
    if (typeof setNameOrGroupName === "function") setNameOrGroupName("");
  };

  // Prefill from route state only for Query Result compose; New Message always starts empty
  useEffect(() => {
    if (!open) return;

    if (isStudentOrCounselor === "parents" && !isQueryPrefill) {
      resetParentRecipient();
      return;
    }

    if (!isQueryPrefill) return;

    if (location?.state) {
      if (location.state.contactType === "parent") {
        setNameOrGroupName({
          parent_email: getParentMessageEmail(location.state) || location.state.name
        });
        setMessageId(undefined);
      }
      // Handle single student/counselor contact
      else if (location.state.name && location.state.id) {
        setNameOrGroupName(location.state.name);
        setMessageId(location.state.id);
      }
      // Handle group message from QueryResult - array of students
      else if (Array.isArray(location.state) && location.state.length > 0) {
        setNameOrGroupName(location.state);
      }
      // Handle "selected All" scenario
      else if (location.state === 'selected All') {
        setNameOrGroupName('selected All');
      }
    }

    // Handle selectedGroupMessageStudent prop for group messaging
    if (selectedGroupMessageStudent) {
      if (
      !Array.isArray(selectedGroupMessageStudent) &&
      selectedGroupMessageStudent.contactType === "parent")
      {
        setNameOrGroupName({
          parent_email: getParentMessageEmail(selectedGroupMessageStudent) || selectedGroupMessageStudent.name
        });
        setMessageId(undefined);
      } else if (Array.isArray(selectedGroupMessageStudent) && selectedGroupMessageStudent.length > 0) {
        setNameOrGroupName(selectedGroupMessageStudent);
      } else if (selectedGroupMessageStudent === 'selected All') {
        setNameOrGroupName('selected All');
      }
    }
  }, [open, isQueryPrefill, isStudentOrCounselor]);

  const deleteAttachment = () => {
    if (!fileDatafromApi) return;
    let body = { message_file: fileDatafromApi?.Status?.image_name };
    MsgDataService.deleteattachment(body).finally(() => setFileDataFromApi());
  };

  const sendMessage = (e) => {
    if (sending) {
      e.preventDefault();
      return;
    }
    if (msg === "" || msg === "undefined") {e.preventDefault();return;}
    let selectedStudent = [];
    if (Array.isArray(NameOrGroupName)) {
      NameOrGroupName.forEach((item) => {
        const studentId = item.id || item["17"] || item["16"];
        if (studentId) {
          selectedStudent.push(studentId);
        }
      });
    }
    const inCounselorContext = (location?.pathname || '').startsWith('/counselor') || (location?.pathname || '').startsWith('/super_admin');
    const isRecruiterStudentDirectMessage =
    isStudentOrCounselor === "students" &&
    !inCounselorContext &&
    !isSelectAllGroupMessage;

    const isQuerySend =
    !freshCompose && (
    Boolean(location?.fromQueryResult) ||
    isSelectAllGroupMessage ||
    Array.isArray(NameOrGroupName));

    let obj;
    if (isRecruiterStudentDirectMessage) {
      if (!hasRecruiterStudentParentSelection(sendToStudent, sendToParent)) {
        e.preventDefault();
        return;
      }
      const dstId = Array.isArray(NameOrGroupName) ? selectedStudent : messageId;
      if (!dstId || Array.isArray(dstId) && dstId.length === 0) {
        e.preventDefault();
        return;
      }
      obj = buildRecruiterStudentParentPayload({
        messageBody: typeof msg === "object" ? msg.messages.en.body : msg,
        dstId,
        sendToStudent,
        sendToParent,
        attachmentUrl: fileDatafromApi?.Status?.image_name,
        single: !isQuerySend
      });
    } else {
      if (isStudentOrCounselor === "parents") {
        const parentEmail = String(parentRecipientEmail || "").trim();
        if (!parentEmail) {
          e.preventDefault();
          return;
        }
        const parentPayloadArgs = {
          messageBody: typeof msg === "object" ? msg.messages.en.body : msg,
          email: parentEmail,
          sendToParent: true,
          sendToStudent: false,
          useParentEmail: true,
          attachmentUrl: fileDatafromApi?.Status?.image_name,
          single: !isQuerySend
        };
        obj = inCounselorContext
          ? buildCounselorStudentParentPayload(parentPayloadArgs)
          : buildRecruiterStudentParentPayload(parentPayloadArgs);
      } else {
      obj = {
        message_body: typeof msg === "object" ? msg.messages.en.body : msg,
        dst_id: Array.isArray(NameOrGroupName) ? selectedStudent : [messageId],
        event_type:
        isStudentOrCounselor === "counselors" ? "recruiter_counselor" :
        isStudentOrCounselor === "students" ? inCounselorContext ? "counselor_student" : "recruiter_student" :
        isStudentOrCounselor === "international-students" ? "international_student" : null
      };
      if (fileDatafromApi) obj.attachment_url = fileDatafromApi?.Status?.image_name;
      if (isStudentOrCounselor === "international-students") {
        obj.is_international = true;
      } else if (selected) {
        obj.parent_ack = selected;
      }
      if (!isQuerySend) {
        obj.single = true;
      }
      }
    }
    if (typeof setShowNotificationAlert === "function") setShowNotificationAlert(true);
    setSending(true);
    MsgDataService.sendMessage(obj)
    .then((data) => {
      if (data?.data?.error) {
        showApiError({ response: { data: data.data } });
      } else {
        setNameOrGroupName();
        setMsg();
        setSelected(false);
        setSendToStudent(false);
        setSendToParent(false);
        if (typeof setSelectedGroupMessageStudent === "function") setSelectedGroupMessageStudent([]);
        if (typeof setOpen === "function") setOpen(false);
        closeHandler();
        showSendSuccess(data);
        if (typeof getMsgData === "function") getMsgData();
      }
    })
    .catch((error) => showApiError(error))
    .finally(() => {
      if (typeof setShowNotificationAlert === "function") setShowNotificationAlert(false);
      setFileDataFromApi();
      setSending(false);
    });
  };

  const handleVerifyNudge = async () => {
    const body = getMessageBody();
    if (!body) return;
    if (noGroupRecipientSelected) {
      swal({
        text: "Please select at least one recipient (Students or Parents).",
        icon: "warning",
        dangerMode: true,
        buttons: { confirm: true },
        closeOnClickOutside: false
      });
      return;
    }
    setVerifying(true);
    try {
      const res = await MsgDataService.verifyNudge(buildAllSelectedPayload());
      setVerifyNudgeResponse(res?.data || {});
      try {
        await MsgDataService.sendOtp();
        setMessageVerified(true);
        setShowOtpModal(true);
      } catch (otpError) {
        showApiError(otpError);
      }
    } catch (error) {
      showApiError(error);
    } finally {
      setVerifying(false);
    }
  };

  const getEstimatedCost = () => {
    const data = verifyNudgeResponse || {};
    return data.estimated_cost || data?.data?.estimated_cost || "";
  };

  const finalizeVerifiedGroupMessage = async (otp) => {
    setOtpSubmitting(true);
    try {
      await MsgDataService.verifyOtp({ otp: Number(otp) });
    } catch (error) {
      showApiError(error);
      setOtpSubmitting(false);
      return;
    }

    try {
      await MsgDataService.twilioMessageCostEstimation({
        estimated_cost: getEstimatedCost(),
        message_body: getMessageBody()
      });
    } catch (error) {
      showApiError(error);
      setOtpSubmitting(false);
      return;
    }

    try {
      setShowNotificationAlert(true);
      const payload = MsgDataService.buildApprovalPayload(
        buildAllSelectedPayload(),
        verifyNudgeResponse
      );
      const previousEndpoint = routes.query_result_pagination.query_result_pagination;
      const response = await MsgDataService.submitMessageApproval(
        payload,
        previousEndpoint
      );
      setShowOtpModal(false);
      setOpen(false);
      closeHandler();
      setNameOrGroupName();
      setMsg();
      setSelected(false);
      setSelectedGroupMessageStudent([]);
      resetVerifyFlowState();
      setFileDataFromApi();
      getMsgData();
      showSendSuccess(response, "Your message has been submitted for approval successfully!");
    } catch (error) {
      showApiError(error);
    } finally {
      setOtpSubmitting(false);
      setShowNotificationAlert(false);
    }
  };

  const handleResendOtp = async () => {
    setOtpResending(true);
    try {
      await MsgDataService.resendOtp();
      setOtpResendTick((t) => t + 1);
    } catch (error) {
      showApiError(error);
    } finally {
      setOtpResending(false);
    }
  };

  const onModalClose = () => {
    resetVerifyFlowState();
    if (parentSearchTimeout.current) clearTimeout(parentSearchTimeout.current);
    parentSearchRequestId.current += 1;
    lastParentQuery.current = "";
    setMessageId(undefined);
    setNameOrGroupName();
    setStudent([]);
    setLoadingNameForStudent(false);
    setShowStudentContainer(false);
    closeHandler();
  };

  // UI RENDER
  return (
    <div>
      <Modal isOpen={open} toggle={onModalClose} centered size="xl" modalClassName="newMessageModalDialog">
        <ModalHeader style={{ borderBottom: 'none', padding: '16px 24px 4px', position: 'relative' }}>
          <h5 style={{ margin: 0, fontWeight: 600, fontSize: 20 }}>New Message</h5>
          <img
            src={closeIcon}
            alt="close"
            onClick={onModalClose}
            className="modal-close-icon"
            style={{ width: 30, height: 30, cursor: 'pointer', position: 'absolute', right: 16, top: 12 }} />

        </ModalHeader>
        <ModalBody style={{ padding: '8px 24px 24px' }}>
          {/* Recipient selector */}
          <div style={{ marginBottom: 18 }}>
            <label style={{ fontSize: 13, fontWeight: 600, color: '#09425A', marginBottom: 6, display: 'block' }}>Recipient</label>
            <div style={{ position: 'relative' }}>
              {isParentQueryContact && parentRecipientEmail ?
              <div style={{
                width: '100%',
                background: '#F8F9FA',
                border: '2px solid #75BF43',
                borderRadius: 14,
                padding: '12px 16px',
                fontSize: 15,
                color: '#09425A',
                fontWeight: 500,
                minHeight: 48
              }}>
                  {parentRecipientEmail}
                </div> :
              Array.isArray(NameOrGroupName) && NameOrGroupName.length > 0 ?
              <div style={{
                width: '100%',
                background: '#F8F9FA',
                border: '2px solid #75BF43',
                borderRadius: 14,
                padding: '12px 16px',
                fontSize: 15,
                minHeight: 48,
                maxHeight: 200,
                overflowY: 'auto'
              }}>
                  {NameOrGroupName.length === 1 ?
                <div style={{ color: '#09425A', fontWeight: 500 }}>
                      {`${NameOrGroupName[0]["1"] || 'Unknown'} ${NameOrGroupName[0]["2"] || 'Student'}`}
                    </div> :

                <div style={{ color: '#09425A', fontWeight: 500 }}>
                      {`${NameOrGroupName.length} students selected`}
                      <div style={{ fontSize: 13, marginTop: 4, color: '#666', maxHeight: 120, overflowY: 'auto' }}>
                        {NameOrGroupName.map((student, idx) =>
                    <div key={idx} style={{ marginBottom: 2 }}>
                            • {`${student["1"] || 'Unknown'} ${student["2"] || 'Student'}`}
                          </div>
                    )}
                      </div>
                    </div>}

                </div> :
              NameOrGroupName === 'selected All' ?
              <div style={{
                width: '100%',
                background: '#F8F9FA',
                border: '2px solid #75BF43',
                borderRadius: 14,
                padding: '12px 16px',
                fontSize: 15,
                color: '#09425A',
                fontWeight: 500
              }}>
                  {`All students selected (${numberOfStudents || 'All'} students)`}
                </div> :

              <input
                ref={inputRef}
                value={typeof NameOrGroupName === 'object' && NameOrGroupName ?
                isStudentOrCounselor === 'parents' ?
                getParentDisplayEmail(NameOrGroupName) || getParentDisplayName(NameOrGroupName) :
                NameOrGroupName.name || '' :
                NameOrGroupName || ''}
                placeholder={isStudentOrCounselor === 'parents' ? 'Search by email' : `Search ${isStudentOrCounselor?.replace(/-/g, ' ')}`}
                onChange={handleNameOrGroupChange}
                onFocus={clearGroupSelection}
                style={{
                  width: '100%',
                  background: '#FFFFFF',
                  border: '2px solid #75BF43',
                  borderRadius: 14,
                  padding: '12px 16px',
                  fontSize: 15,
                  outline: 'none'
                }} />}


              {loadingNameForStudent &&
              <div style={{ position: 'absolute', top: 10, right: 14 }}>
                  <Loader type="ThreeDots" color="#1395F2" height={30} width={30} />
                </div>}

              {showStudentContainer && student?.length > 0 && !Array.isArray(NameOrGroupName) && NameOrGroupName !== 'selected All' &&
              <div style={{ position: 'absolute', top: 54, left: 0, right: 0, background: '#fff', border: '1px solid #D0E4F1', borderRadius: 12, maxHeight: 220, overflowY: 'auto', zIndex: 10 }}>
                  {student.map((itm) =>
                <div
                  key={getParentDisplayEmail(itm) || itm.id}
                  onClick={() => selectStudent(itm)}
                  style={{ padding: '10px 14px', cursor: 'pointer', fontSize: 14, borderBottom: '1px solid #eef3f7' }}>

                      {isStudentOrCounselor === 'parents' ?
                  <div style={{ fontWeight: 600, color: '#0F2434' }}>
                          {getParentDisplayEmail(itm) || getParentDisplayName(itm)}
                        </div> :

                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                          <span>{itm.name}</span>
                          <span style={{ opacity: .6 }}>{itm.grad_year}</span>
                        </div>}

                    </div>
                )}
                </div>}

            </div>
          </div>

          {/* Scheduled message templates (match Counselor style) */}
          <div style={{ marginBottom: 16 }}>
            <div
              role="button"
              tabIndex={0}
              onClick={accordionHandler}
              onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && accordionHandler()}
              style={{
                width: '100%',
                background: '#FFFFFF',
                border: '2px solid #75BF43',
                borderRadius: 22,
                padding: '12px 16px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                // fontWeight: 600,
                // color: '#09425A',
                cursor: 'pointer'
              }}>

              <span>Choose a Scheduled Message Template</span>
              <span style={{ transform: openAccordion ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform .2s ease' }}>
                <KeyboardArrowDownIcon style={{ color: '#09425A' }} />
              </span>
            </div>
            {openAccordion &&
            <div style={{
              background: '#FFFFFF',
              border: '1px solid #D0E4F1',
              borderRadius: 14,
              maxHeight: 260,
              overflowY: 'auto',
              marginTop: 8,
              padding: 8
            }}>
                {Array.isArray(cannedMsgData) && cannedMsgData.length > 0 ?
              cannedMsgData.map((item, idx) =>
              <div
                key={idx}
                onClick={() => selectTemplate(item)}
                style={{
                  border: '1px solid #E7F2FA',
                  borderRadius: 12,
                  padding: '10px 12px',
                  margin: '8px 6px',
                  cursor: 'pointer',
                  background: '#F9FCFF'
                }}>

                      <div style={{ fontWeight: 700, color: '#0F2434', marginBottom: 6 }}>
                        {item?.messages?.en?.subject || 'Untitled'}
                      </div>
                      <div style={{ color: '#406079', fontSize: 14, whiteSpace: 'pre-wrap' }}>
                        {item?.messages?.en?.body}
                      </div>
                    </div>
              ) :

              <div style={{ padding: 12, color: '#406079' }}>No templates available.</div>}

              </div>}

          </div>

          {/* Message composer */}
          <div style={{ marginBottom: 14 }}>
            <label style={{ fontSize: 13, fontWeight: 600, color: '#09425A', marginBottom: 6, display: 'block' }}>Message</label>
            {isSelectAllGroupMessage &&
            <p
              style={{
                fontSize: 12,
                color: '#6b7280',
                margin: '0 0 8px',
                lineHeight: 1.4
              }}>

                Note: Use only standard English characters (GSM-7). Avoid emojis and special symbols.
              </p>}

            <textarea
              rows={5}
              placeholder="Type your message..."
              value={typeof msg === 'object' ? msg.messages.en.body : msg || ''}
              onChange={messageInputHandler}
              disabled={messageVerified}
              style={{
                width: '100%',
                background: messageVerified ? '#F3F4F6' : '#FFFFFF',
                border: '2px solid #75BF43',
                borderRadius: 22,
                padding: '14px 16px',
                fontSize: 15,
                outline: 'none',
                resize: 'vertical',
                minHeight: 120,
                cursor: messageVerified ? 'not-allowed' : 'text'
              }} />

          </div>

          {/* Action bar */}
          <div style={{ padding: '12px 0 0', display: 'flex', justifyContent: 'space-between', alignItems: 'center', columnGap: 24, flexWrap: 'nowrap' }}>
            <div style={{ display: 'flex', alignItems: 'center', columnGap: 20, flexWrap: 'nowrap', flex: 1, minWidth: 0 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 14, flexShrink: 0 }}>
                {/* <div style={{ cursor: 'pointer', width: 46, height: 46, borderRadius: 12, background: '#E5F4E4', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                   <img src={galleryIcon} alt="gallery" style={{ width: 28, height: 28 }} />
                  </div> */}
                <div
                  style={{
                    cursor: 'pointer',
                    width: 46,
                    height: 46,
                    borderRadius: 12,
                    background: '#E5F4E4',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                  title="Attach file">

                  <label
                    htmlFor="fileUploaderRecruiterModal"
                    style={{
                      cursor: 'pointer',
                      margin: 0,
                      display: 'flex'
                    }}>

                    <img
                      src={attachmentIcon}
                      alt="attachment"
                      style={{ width: 26, height: 26 }} />

                  </label>

                  <input
                    id="fileUploaderRecruiterModal"
                    type="file"
                    ref={ref}
                    onChange={handleFileChange}
                    style={{ display: 'none' }} />

                </div>
                {/* <div style={{ cursor: 'pointer', width: 46, height: 46, borderRadius: 12, background: '#E5F4E4', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                   <img src={smileIcon} alt="emoji" style={{ width: 28, height: 28 }} />
                  </div> */}
              </div>
              {showStudentParentToggles ?
              <div style={{ display: 'flex', alignItems: 'center', gap: 24, marginLeft: 12, whiteSpace: 'nowrap' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <div
                    onClick={toggleGroupSendStudents}
                    style={{ cursor: 'pointer', width: 46, height: 46, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>

                      <img src={groupSendStudents ? checkmarkselected : checkmarkIcon} alt={groupSendStudents ? 'checked' : 'unchecked'} style={{ width: 28, height: 28 }} />
                    </div>
                    <span onClick={toggleGroupSendStudents} style={{ cursor: 'pointer', fontSize: 14, fontWeight: 500 }}>
                      Send To Students
                    </span>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <div
                    onClick={toggleGroupSendParents}
                    style={{ cursor: 'pointer', width: 46, height: 46, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>

                      <img src={groupSendParents ? checkmarkselected : checkmarkIcon} alt={groupSendParents ? 'checked' : 'unchecked'} style={{ width: 28, height: 28 }} />
                    </div>
                    <span onClick={toggleGroupSendParents} style={{ cursor: 'pointer', fontSize: 14, fontWeight: 500 }}>
                      Send To Parents
                    </span>
                  </div>
                </div> :
              showRecruiterStudentParentToggles ?
              <div style={{ display: 'flex', alignItems: 'center', gap: 24, marginLeft: 12, whiteSpace: 'nowrap' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <div
                    onClick={toggleSendToStudent}
                    style={{ cursor: 'pointer', width: 46, height: 46, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>

                      <img src={sendToStudent ? checkmarkselected : checkmarkIcon} alt={sendToStudent ? 'checked' : 'unchecked'} style={{ width: 28, height: 28 }} />
                    </div>
                    <span onClick={toggleSendToStudent} style={{ cursor: 'pointer', fontSize: 14, fontWeight: 500 }}>
                      {isMultiStudentSelection ? 'Send To Students' : 'Send to Student'}
                    </span>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <div
                    onClick={toggleSendToParent}
                    style={{ cursor: 'pointer', width: 46, height: 46, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>

                      <img src={sendToParent ? checkmarkselected : checkmarkIcon} alt={sendToParent ? 'checked' : 'unchecked'} style={{ width: 28, height: 28 }} />
                    </div>
                    <span onClick={toggleSendToParent} style={{ cursor: 'pointer', fontSize: 14, fontWeight: 500 }}>
                      {isMultiStudentSelection ? 'Send To Parents' : 'Send to parent'}
                    </span>
                  </div>
                </div> :
              isStudentOrCounselor === 'students' && inCounselorContext &&
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginLeft: 12, whiteSpace: 'nowrap' }}>
                  <div
                  onClick={sendCopyToParents}
                  style={{ cursor: 'pointer', width: 54, height: 54, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'all .25s ease' }}>

                    <img src={selected ? checkmarkselected : checkmarkIcon} alt={selected ? 'checked' : 'unchecked'} style={{ width: 28, height: 28 }} />
                  </div>
                  <span
                  onClick={sendCopyToParents}
                  style={{ cursor: 'pointer', fontSize: 14, fontWeight: 500 }}>

                    Send copy to parent
                  </span>
                </div>}

              {fileDatafromApi &&
              <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                  <p style={{ color: '#008000', marginBottom: 0 }}>
                    {fileDatafromApi?.Status?.filename.slice(0, 15)}
                  </p>
                  <div onClick={deleteAttachment} style={{ cursor: 'pointer' }}>
                    <Clear className="cancelAttachment" />
                  </div>
                </div>}

            </div>
            {isSelectAllGroupMessage ?
            <button
              type="button"
              onClick={handleVerifyNudge}
              className="sendmessage"
              style={{
                background: '#1395F2',
                border: '3px solid #FFFFFF',
                color: '#FFFFFF',
                padding: '14px 34px',
                borderRadius: 18,
                fontSize: 16,
                fontWeight: 600,
                display: 'flex',
                alignItems: 'center',
                gap: 10,
                boxShadow: '0 0 0 2px #1395F2',
                cursor: !getMessageBody() || messageVerified || verifying || noGroupRecipientSelected ? 'not-allowed' : 'pointer',
                opacity: !getMessageBody() || messageVerified || verifying || noGroupRecipientSelected ? 0.5 : 1,
                transition: 'opacity .3s ease'
              }}
              disabled={!getMessageBody() || messageVerified || verifying || noGroupRecipientSelected}>

                {verifying ? "Verifying..." : "Verify"}
              </button> :

            <button
              onClick={sendMessage}
              className="sendmessage"
              style={{
                background: '#1395F2',
                border: '3px solid #FFFFFF',
                color: '#FFFFFF',
                padding: '14px 34px',
                borderRadius: 18,
                fontSize: 16,
                fontWeight: 600,
                display: 'flex',
                alignItems: 'center',
                gap: 10,
                boxShadow: '0 0 0 2px #1395F2',
                cursor: !msg || !hasRecipientSelected || noRecruiterStudentRecipientSelected || sending ? 'not-allowed' : 'pointer',
                opacity: !msg || !hasRecipientSelected || noRecruiterStudentRecipientSelected || sending ? 0.5 : 1,
                transition: 'opacity .3s ease'
              }}
              disabled={!msg || !hasRecipientSelected || noRecruiterStudentRecipientSelected || sending}>

                {sending ?
              <MessageSendSpinner /> :

              <img src={sendIcon} alt="send" style={{ width: 22, height: 22 }} />}

                SEND
              </button>}

          </div>
        </ModalBody>
      </Modal>
      <OtpVerifyModal
        isOpen={showOtpModal}
        onCancel={() => setShowOtpModal(false)}
        onSubmit={finalizeVerifiedGroupMessage}
        onResend={handleResendOtp}
        submitting={otpSubmitting}
        resending={otpResending}
        resendTick={otpResendTick} />

    </div>);

};

export default ModalExample;
